import { render, staticRenderFns } from "./ChannelDetails.vue?vue&type=template&id=c4a6f220&"
import script from "./ChannelDetails.vue?vue&type=script&lang=js&"
export * from "./ChannelDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports